import request from './request'

// ==================== 申报助手（CRM 代理 /api/agent） ====================

/**
 * 创建申报任务
 * @param {object} data - { company_id, policy_code }
 */
export function createAgentTask(data) {
  return request.post('/agent/tasks', data)
}

/**
 * 我的任务列表（引用 + 状态联查）
 */
export function getAgentTaskList() {
  return request.get('/agent/tasks')
}

/**
 * 任务快照（页面恢复 / 轮询降级）
 * @param {string} taskId
 */
export function getAgentTask(taskId) {
  return request.get(`/agent/tasks/${taskId}`)
}

/**
 * interrupt 应答
 * @param {string} taskId
 * @param {object} payload - 各 interrupt 类型协议见 agentProtocol.js
 */
export function resumeAgentTask(taskId, payload) {
  return request.post(`/agent/tasks/${taskId}/resume`, { payload })
}

/**
 * 政策编码选项（新建任务下拉）
 */
export function getAgentPolicies() {
  return request.get('/agent/policies')
}

/**
 * 创建申报助手会话（编排：建会话+建任务+绑定）
 * @param {object} data - { company_id?, policy_code?, kb_spaces?, initial_message, attachment_ids?, skill? }
 */
export function createAgentConversation(data) {
  return request.post('/agent/conversations', data)
}

/**
 * 会话空间更新
 * @param {number} conversationId
 * @param {string[]} kbSpaces
 */
export function updateConversationSpaces(conversationId, kbSpaces) {
  return request.patch(`/agent/conversations/${conversationId}/spaces`, { kb_spaces: kbSpaces })
}

/**
 * 会话中途附件
 * @param {number} conversationId
 * @param {number[]} attachmentIds
 */
export function addConversationAttachments(conversationId, attachmentIds) {
  return request.post(`/agent/conversations/${conversationId}/attachments`, { attachment_ids: attachmentIds })
}

/**
 * 登记任务附件（fileKey → kb_attachment.id）
 * @param {object} data - { file_name, file_key, file_size, file_type }
 */
export function registerAgentFile(data) {
  return request.post('/agent/files/register', data)
}

/**
 * 企业绑定（W0 §3）
 * @param {string} taskId
 * @param {string} companyId
 */
export function bindTaskCompany(taskId, companyId) {
  return request.patch(`/agent/tasks/${taskId}/company`, { company_id: companyId })
}
